import { useAtom, useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { brandGroupIdAtom } from '~/atoms'
import {
  BrandSelector,
  type BrandSelectorProps,
} from '~/components/features/BrandSelector'
import { useLogEvent } from '~/hooks/useLogEvent'
import {
  type Brand,
  useSurveyQueryAvailableBrandGroups,
} from '~/hooks/useSurveyQuery'
import { exists } from '~/utils'

import { brandIdsAtom } from '../atoms'

export const BrandSelectorContainer = () => {
  const { t } = useTranslation()
  const brandGroups = useSurveyQueryAvailableBrandGroups()

  const brandGroupId = useAtomValue(brandGroupIdAtom)

  const [brandIds, setBrandIds] = useAtom(brandIdsAtom)

  const allBrands = React.useMemo(
    () =>
      brandGroups
        .find(({ id }) => id === brandGroupId)
        ?.brands?.filter((brand): brand is Brand => exists(brand)) ?? [],
    [brandGroupId, brandGroups],
  )

  const selectedBrandId = brandIds[0] ?? null

  const logEvent = useLogEvent()
  const handleChange = React.useCallback<
    EH<BrandSelectorProps<Brand>, 'onChange'>
  >(
    (brandId) => {
      setBrandIds([brandId].filter(exists))
      logEvent('Select brand')
    },
    [logEvent, setBrandIds],
  )

  return (
    <BrandSelector
      brands={allBrands}
      disabled={allBrands.length === 0}
      isNullSelectable={true}
      nullText={t('select_brand')}
      value={selectedBrandId}
      width={360}
      onChange={handleChange}
    />
  )
}
